import { render, staticRenderFns } from "./ServidoresComDoisVinculos.vue?vue&type=template&id=54737036"
import script from "./ServidoresComDoisVinculos.vue?vue&type=script&lang=ts"
export * from "./ServidoresComDoisVinculos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports